var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"marketing-wysiwyg"},[_c('VueEditor',{attrs:{"value":_vm.value,"editorToolbar":_vm.editorToolbar},on:{"input":function($event){return _vm.$emit('input', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }